/*
  <mh-playshorts> — vidéos PlayShorts du produit dans MH · Avantages + vidéos.
  L'intégration PlayShorts du formulaire d'achat (snippets/add-to-cart-product.liquid) monte ses
  bulles dans #playshorts : ce conteneur est déplacé ici, où le CSS transforme les bulles en cartes
  (Figma « Card - Story ») avec les flèches du carrousel. Le lecteur et l'ajout au panier restent
  ceux de l'app. Sans vidéo pour le produit, l'élément reste masqué et le panneau garde son
  contenu (blocs PlayShorts, Tolstoy ou visuels d'aperçu).

  <mh-playshorts hidden>
    <div data-mh-playshorts-mount></div>
    <button data-mh-playshorts-prev>…</button>
    <button data-mh-playshorts-next>…</button>
  </mh-playshorts>
*/
if (!customElements.get('mh-playshorts')) {
  customElements.define('mh-playshorts', class extends HTMLElement {
    connectedCallback() {
      this.widget = document.getElementById('playshorts');
      const mount = this.querySelector('[data-mh-playshorts-mount]');
      if (!this.widget || !mount) return;
      mount.append(this.widget);

      this.prev = this.querySelector('[data-mh-playshorts-prev]');
      this.next = this.querySelector('[data-mh-playshorts-next]');
      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));

      this.onScroll = () => this.update();
      this.resizeObserver = new ResizeObserver(this.onScroll);

      // PlayShorts construit ses bulles après le chargement de son script : on suit ses ajouts
      this.mutationObserver = new MutationObserver(() => this.refresh());
      this.mutationObserver.observe(this.widget, { childList: true, subtree: true });
      this.refresh();
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    refresh() {
      const items = this.widget.querySelectorAll('.ps-story-item');

      // Vignettes en grand (540 × 960) : PlayShorts ne les charge qu'à son propre rythme
      items.forEach((item) => {
        const image = item.querySelector('img[data-src]:not([src])');
        if (image) {
          image.loading = 'lazy';
          image.src = image.dataset.src;
        }
      });

      const hasVideos = items.length > 0;
      this.hidden = !hasVideos;
      this.closest('.mh-highlights__media')?.classList.toggle('mh-highlights__media--playshorts', hasVideos);

      const track = this.widget.querySelector('.ps-stories');
      if (track && track !== this.track) {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver.disconnect();
        this.track = track;
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver.observe(this.track);
      }
      this.update();
    }

    // Une carte et son écart par clic
    go(direction) {
      const item = this.track?.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    update() {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      this.toggleAttribute('data-scrollable', max > 0);
    }
  });
}
